"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightPanel = exports.BuyButton = exports.BackgroundGradient = exports.LeftPanel = exports.Wrap = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.Wrap = (0, app_1.styled)(ui_1.Grid) `
  min-height: 60rem;
  @media ${app_1.mobile} {
    grid-template-columns: 1fr;
    > div:first-of-type {
      grid-row: 2;
    }
  }
`;
exports.LeftPanel = (0, app_1.styled)(ui_1.GridItem) `
  background: #000000;
  padding: ${(theme) => theme.spacing.extraLarge};
  padding-right: calc(${(theme) => theme.spacing.extraLarge} * 2);
  padding-top: 35%;
  display: flex;
  flex-direction: column;

  > div {
    flex: 1;
  }

  @media ${app_1.mobile} {
    padding: ${(theme) => theme.spacing.medium};
    > div {
      margin-bottom: ${(theme) => theme.spacing.extraLarge};
    }
  }
`;
exports.BackgroundGradient = app_1.styled.div ``;
exports.BuyButton = (0, app_1.styled)(ui_1.Button) `
  width: 100%;
  text-transform: uppercase;
`;
exports.RightPanel = (0, app_1.styled)(ui_1.GridItem) `
  background: #000000;
  position: relative;
  flex-direction: column;
  /**
  justify-content: ${(_, { $single }) => ($single ? 'flex-end' : 'flex-start')};
  */
  justify-content: flex-start;
  overflow: hidden;
  :after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, black -15%, transparent 50%);
    pointer-events: none;
  }
  > div:first-of-type {
    overflow: auto;
    max-height: 100vh;
    width: 100%;
  }

  @media ${app_1.mobile} {
    height: 85vh;
    > div:first-of-type > div {
      height: 100%;
    }
  }
`;
